__turbopack_context__.v({
  "Footer": "kQc2fa_Footer",
  "Footer__BottomRow": "kQc2fa_Footer__BottomRow",
  "Footer__Column": "kQc2fa_Footer__Column",
  "Footer__Column--Desktop": "kQc2fa_Footer__Column--Desktop",
  "Footer__Column--Links": "kQc2fa_Footer__Column--Links",
  "Footer__Column--Logo": "kQc2fa_Footer__Column--Logo",
  "Footer__Column--Mobile": "kQc2fa_Footer__Column--Mobile",
  "Footer__Column--Social": "kQc2fa_Footer__Column--Social",
  "Footer__Container": "kQc2fa_Footer__Container",
  "Footer__Content": "kQc2fa_Footer__Content",
  "Footer__CookieSettings": "kQc2fa_Footer__CookieSettings",
  "Footer__Copyright": "kQc2fa_Footer__Copyright",
  "Footer__Link": "kQc2fa_Footer__Link",
  "Footer__LinkList": "kQc2fa_Footer__LinkList",
  "Footer__LinkList--Links": "kQc2fa_Footer__LinkList--Links",
  "Footer__LinkList--Social": "kQc2fa_Footer__LinkList--Social",
  "Footer__LinkListItem": "kQc2fa_Footer__LinkListItem",
  "Footer__Logo": "kQc2fa_Footer__Logo",
  "Footer__Placeholder": "kQc2fa_Footer__Placeholder",
  "Footer__Search": "kQc2fa_Footer__Search",
  "Footer__SearchContainer": "kQc2fa_Footer__SearchContainer",
  "Footer__SearchField": "kQc2fa_Footer__SearchField",
  "Footer__SearchField--Active": "kQc2fa_Footer__SearchField--Active",
  "Footer__SoMeIcon": "kQc2fa_Footer__SoMeIcon",
  "Footer__SocialLink": "kQc2fa_Footer__SocialLink",
  "Footer__Submit": "kQc2fa_Footer__Submit",
});
